import type { MunicipalityKind } from '../types/pre-registration.types';

export const NO_DATA_LABEL = 'Sin dato';
export const NO_LOCALITY_LABEL = 'Sin localidad';

export const MUNICIPALITY_KIND_LABELS: Record<MunicipalityKind, string> = {
  municipality: 'Municipio',
  municipal_commission: 'Comisión municipal',
};

// `YYYY-MM-DD` date-only values: format without going through Date to avoid timezone shifts
export const formatDateOnly = (value: string | null): string => {
  if (!value) return '—';
  const [year, month, day] = value.split('-');
  return `${day}/${month}/${year}`;
};

export const formatTimestamp = (value: string): string =>
  new Date(value).toLocaleDateString('es-AR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  });

// `null` means "not reported"; 0 is a real value
export const formatOptionalCount = (value: number | null): string =>
  value === null ? NO_DATA_LABEL : String(value);

export const DATE_TIME_ZONE_LABEL = 'Hora de Argentina (UTC-3)';

// Timestamps are UTC; show them in Jujuy's local time, 24 h
const dateTimeFormat = new Intl.DateTimeFormat('es-AR', {
  day: '2-digit',
  month: '2-digit',
  year: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
  hourCycle: 'h23',
  timeZone: 'America/Argentina/Jujuy',
});

// Built from parts: Intl puts a comma between date and time (`17/10/2026, 14:04`)
export const formatDateTime = (value: string): string => {
  const parts = Object.fromEntries(
    dateTimeFormat.formatToParts(new Date(value)).map((part) => [part.type, part.value])
  );
  return `${parts.day}/${parts.month}/${parts.year} ${parts.hour}:${parts.minute}`;
};

// Same minute as shown on screen
export const isSameMinute = (a: string, b: string): boolean =>
  formatDateTime(a) === formatDateTime(b);

export const formatUserName = (user: { firstName: string; lastName: string } | null): string =>
  user ? `${user.firstName} ${user.lastName}`.trim() : '—';
